import React from "react";

import { IProductTemplateAttribute } from "components/dashboard/product-template-table/utils/interfaces";
import { InputNumber } from "primereact/inputnumber";
import { T } from "services/lang/LanguageService";

type DatasetTypeProps = {
  attribute: IProductTemplateAttribute;
  onAttrChangeInDataset: React.Dispatch<React.SetStateAction<IProductTemplateAttribute>>;
};

const DatasetType: React.FC<DatasetTypeProps> = ({ attribute, onAttrChangeInDataset }) => {
  return (
    <div className=" p-field p-col-2">
      <label>{T("config.decimal-places")}</label>
      <InputNumber
        placeholder={T("message.number-of-decimal-places-to-show")}
        value={attribute.decimalPlaces}
        onChange={e => onAttrChangeInDataset(prev => ({ ...prev, decimalPlaces: e.value ?? 2 }))}
        name="decimalPlaces"
        className="p-inputtext-sm"
      />
    </div>
  );
};

export default DatasetType;
